import closeIcon from '../../assets/icons/close.png'
import { useEffect, useState } from "react";
import axios from "axios";
import AquaButton from "../main/app-download/AquaButton";
import { AuthContext } from '../layout/AuthContext'
import { useContext } from "react";
import { Link } from "react-router-dom";

const LoginModal = ({

  isOpen,
  onClose,
  timeId

}) => {

const [redirectAddres, setRedirectAddress]  = useState('')

const { isLogged, loading } = useContext(AuthContext);

const [loginText, setLoginText] = useState('')

     const loginCheck = () => {
      let loginCheck = false;
      console.log("isLogged: " + isLogged);
      	axios.get('https://medizen.ir/checkAccess.php')
	.then(response=>{
    console.log(response);
		const data = response.data
		console.log(data);
		
		if(data.is_logged){
        loginCheck = true;
		}
	}).catch(error=>{
		console.log('مشکلی پیش امده',error)
	}).finally()
 if (!loginCheck) {

  setLoginText('ابتدا وارد شوید');
  const currentUrl = window.location.href;
  setRedirectAddress(`https://medizen.ir/panel?callback_url=${encodeURIComponent(currentUrl)}`)
  
} else {

    setLoginText('ابتدا ثبت نام کنید')
  window.location.href = `https://medizen.ir/panel/panel/?m=applet&sub=add_appointment&apid=${timeId}`;

  setRedirectAddress(
    `https://medizen.ir/panel/panel/?m=applet&sub=add_appointment&apid=${timeId}`
  );
}
  }

    return(
         <div
      className="fixed inset-0 z-[100] flex items-center
      justify-center bg-black bg-opacity-50"
    >
        <div
        className="relative bg-white shadow-2xl p-5 md:p-7 rounded-[15px] z-[101]
        flex flex-col gap-7 overflow-y-auto  max-h-[90%] w-11/12 md:w-fit
        "
        onClick={(e) => e.stopPropagation()}
      >
        {/* دکمه بستن */}
        <div className="flex justify-between items-center border-b-2 pb-5 md:pb-7">
          <span className="text-[18px] md:text-[24px] font-semibold">ورود به حساب کاربری</span>
           <button
           className=" bg-gray-100 rounded-[50%] w-[44px] h-[44px] 
          flex justify-center items-center text-center"
           onClick={onClose}
           >
            <img src={closeIcon}
           alt=""
           className="w-[15px] object-contain"
           />
           </button>
        </div>
   <div
   className='mb-8 flex flex-col gap-7 mt-'
   >
       <div
      className='text-center flex gap-1 justify-center my-2 text-[18px]'>
         <span>
             برای رزرو نوبت، ابتدا باید وارد 
         </span>
          <span
          className='text-aqua'
          >
            حساب کاربری
          </span>
         <span>
              خود شوید.
         </span>
      </div>
       <div className='flex gap-3 justify-center'>
         <a
         target='_self'
        className='bg-aqua text-white text-center rounded-[10px]
        w-11/12 py-3 hover:bg-[#18cbc2] transition-all'
        onClick={()=>loginCheck()}
        href={redirectAddres}
        >
            ورود
        </a>
         <a
        className='border-2 border-aqua text-aqua
        text-center rounded-[10px] w-11/12 py-3 hover:bg-aqua hover:bg-opacity-30 transition-all'
        onClick={()=>loginCheck()}
        href={redirectAddres}
        >
            ثبت نام
        </a>
       </div>
   </div>
      </div>
    </div>
    )
}
export default LoginModal